import { toast } from "react-toastify";
import { observable } from "mobx";
import { apiOperacao } from "../../api";
import moment from "moment";

export class _SpedStore {
  obs = observable({
    tasks_sped: [] as any[],
    length_tasks_sped: 0 as number,
    loading: false as boolean,
    
    selectedTab: "sped" as string,

  })

  async handleTasksPaged(paged: number, cnpj: string, data_agendamento: any, modelo_arquivo: string | null) {

    let data = data_agendamento && data_agendamento.$d ? data_agendamento.$d : null

    if (!data || moment(data).format("YYYY-MM-DD") == "Data inválida") {
      data = null
    } else {
      data = moment(data).format("YYYY-MM-DD")
    }

    let params = {
      page: paged,
      limit: 15,
      cnpj: !cnpj ? null : cnpj,
      data_agendamento: data,
      modelo_arquivo
    }

    try {

      let resp = await apiOperacao("sped").post("/sped/task/index", params);

      this.obs.tasks_sped = [];
      this.obs.length_tasks_sped = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_sped = resp.data.itens;
        this.obs.length_tasks_sped = resp.data.count
      }

    } catch (ex) { }

  }

  async create_contestacao_task(params: any) {

    try {
      
      let resp = await apiOperacao("sped").post("/sped/task/create", params);

      if (resp.data.ok) {

        toast.success('Solicitação realizada com sucesso', {});

        return true

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) { }

    return false

  }

  async handleDownloadArquivoSped(id: string, cnpj: string) {
    SpedStore.obs.loading = true
    try {
      let resp = await apiOperacao("sped").get(`/sped/task/download/${id}`);

      if (!resp.data.ok) {
        SpedStore.obs.loading = false
        toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});
        return
      }

      const linkSource = `data:application/txt;base64,${resp.data.file}`;
      const downloadLink = document.createElement("a");
      const fileName = cnpj + "- Sped.txt";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

    } catch (ex) { }

    SpedStore.obs.loading = false

  }

}

export const SpedStore = new _SpedStore();
